import { useMessagesWebsocket } from '@liscio/common';

import useWebsocket from './useWebsocket';
import { useHomeData } from 'fetch-utils/users/user-hooks';

/**
 * Firm app wrapper for messages WebSocket subscription
 * 
 * This hook automatically subscribes to MessageChannel for real-time message updates
 * when the user is authenticated and has a valid session.
 */
export default function useMessagesWebsocketFirm(authToken?: string) {
  const websocket = useWebsocket(authToken);
  const { data: homeData } = useHomeData();

  useMessagesWebsocket({
    consumer: websocket.consumer,
    cpaUserId: homeData?.data?.cpa_user_id,
    enabled: Boolean(homeData?.data?.cpa_user_id),
  });
}


